export default __webpack_public_path__ + "static/media/mainfeature_icon1.8b857e9b.png";